/* eslint-enable */
/* eslint-enable */

class AnimationExTabBox {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleExTabBox = this.sectionsContainer.querySelectorAll('.ex-tab-box');
		
		if (!this.$moduleExTabBox.length)
			return;
		
		this.$moduleExTabBoxElements = [];

		this.$moduleExTabBox.forEach(module => {
			this.$moduleExTabBoxElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleExTabBox.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleExTabBoxElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleExTabBox = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleExTabBox[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleExTabBoxElements[index], { clearProps: true });
			}
        });
    
        this.moduleExTabBox.addLabel('step1');
        this.moduleExTabBox.to(this.$moduleExTabBox[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleExTabBox.to(this.$moduleExTabBoxElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationExTabBox;
